import React from "react";
import BookingForm from "./BookingForm";

function BookingPage({ availableTimes, dispatch }) {
  return (
    <section className="min-h-screen py-16 px-6 md:py-20 lg:py-24 bg-gradient-to-br 
      from-slate-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-slate-900">
      
      <div className="max-w-4xl mx-auto text-center">
        {/* Hero heading - Reduced font sizes for harmony */}
        <div className="mb-12 md:mb-16 lg:mb-20">
          <h1 className="text-4xl md:text-3xl lg:text-6xl xl:text-4xl font-serif 
            font-light tracking-tight leading-tight mb-6 
            bg-gradient-to-r from-gray-900 via-gray-700 to-slate-900 dark:from-slate-100 dark:via-gray-300 dark:to-white
            bg-clip-text text-transparent drop-shadow-lg">
            <span className="block">Let's create</span>
            <span className="block">something timeless</span>
          </h1>
          
          {/* Subtler divider */}
          <div className="w-20 h-px mx-auto bg-gradient-to-r from-gray-300 to-transparent dark:from-gray-600 mb-6"></div>
          
          {/* Smaller, more refined subtitle */}
          <p className="text-lg md:text-xl lg:text-1xl font-light text-gray-600 dark:text-gray-400 
            max-w-xl mx-auto leading-relaxed">
            Schedule your session. Capture moments that last forever.
          </p>
        </div>

        {/* Form container - Tighter spacing, better visual hierarchy */}
  <div className="bg-white/90 dark:bg-gray-400/90 
  backdrop-blur-md border border-gray-200 dark:border-gray-600/60
  rounded-2xl shadow-lg p-4 md:p-6 lg:p-8 
  max-w-sm mx-auto  /* ← Ultra-compact: max-w-sm */
  transform hover:shadow-xl hover:-translate-y-1 
  transition-all duration-300">
  
  <BookingForm availableTimes={availableTimes} dispatch={dispatch} />
</div>


        {/* Quote - Smaller, more subtle */}
        <div className="mt-16 pt-8 border-t border-gray-200/30 dark:border-gray-700/40">
          <p className="text-xs md:text-sm font-light text-gray-300 dark:text-gray-400 italic max-w-lg mx-auto leading-relaxed">
            "Photography takes an instant out of time, altering life by holding it still." 
            <br />
            <span className="font-serif font-medium not-italic text-gray-700 dark:text-gray-300">
              – Dorothea Lange
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default BookingPage;
